import Post from './Post';
import withLayout from 'hocs/withLayout';

export type { PostIndexProps, PostPropTypes } from './Post';
export { PostArticle } from './Post';

export default withLayout(Post, { gutter: false, margin: true, topAd: true });
